export function getLocalizedWeekday(date, language, timezone) {
    const locale = language === 'de' ? 'de-AT' : 'en-GB';
    const weekday = new Intl.DateTimeFormat(locale, {
        timeZone: timezone,
        weekday: 'long',
    }).format(date);
    return weekday.charAt(0).toUpperCase() + weekday.slice(1);
}
